import { ReactElement } from 'react';
import ReactDOMServer from 'react-dom/server';

/**
 * Render a React element to a static HTML string for off-screen measurement.
 */
export function renderToMeasureHTML(element: ReactElement): string {
  const errOrig = console.error;
  try {
    console.error = () => void 0;
    return ReactDOMServer.renderToString(element);
  } finally {
    console.error = errOrig;
  }
}
